import MyContext from "../../../contexts/MyContext";
import { TicketForm2 } from "../ticket-forms/TicketForm2";
export const Slide2 = (props) => {
  return (
    <MyContext.Consumer>
      {(context) => (
        <div hidden={context.activeSlide !== 1}>
          <TicketForm2 {...props} />
        </div>
      )}
    </MyContext.Consumer>
  );
};
